import React from "react";
import ResumeTable from "../components/Table/ResumeTable";
import BarGraph from "../components/Graphs/BarGraph";
import ReferenceReport from "../components/Table/ReferenceReport";
import { NetworkService } from "../services/NetworkService";
import Loading from "../components/Loading/Loading";
import {ReportsServices} from "../services/ReportsServices";
import DownloadIcon from '@mui/icons-material/Download';
import ReportIcon from '@mui/icons-material/Report';

const ModelReportDatesBar = ({ report }) => {
  const [idIndicator, setIdIndicator] = React.useState(0);
  const [dataFiltered, setDataFiltered] = React.useState([]);
  const [errorMessage, setErrorMessage] = React.useState(null);

  React.useEffect(() => {
    const fetchDataIndicator = async () => {
      await NetworkService.request({
        url: `indicators?id=${report}`,
        method: "GET",
      }).then((response) => {
        if (response.error & response.status === 500){
          setErrorMessage("Ainda não há entrevistas suficientes para geração de indicadores!")
          return;
        }

        if(response.reference.usableReferenceData){
          response.header.push(response.reference.header[1]);
          response.values.forEach((item, index) => {
            const referenceItem = response.reference.values[index];
            const referenceValue = referenceItem ? parseFloat(referenceItem[1]) || 0 : 0;
            item.push(referenceValue);
          });
        }
        const formatString = (str) => {
          let formattedStr = str.replace(/^\*\s*/, '');
          formattedStr = formattedStr.charAt(0).toUpperCase() + formattedStr.slice(1);
          return formattedStr;
        };
        response.header = response.header.map(formatString);
        response.values.forEach((item) => {
          item[0] = formatString(item[0]);
        });
        setDataFiltered(response);
        setIdIndicator(report);
      });
    }
    if(report !== idIndicator) fetchDataIndicator().then();
  }, [idIndicator, report]);

  function onClickDownloadReport() {
    ReportsServices.downloadReport(report).then();
  }

  if (dataFiltered === undefined || dataFiltered.length === 0) {
    return null;
  }

  return (
    <>
      {report === idIndicator ?
        <div className="flex-1 w-full flex  flex-col h-full pt-14 px-6 items-center overflow-auto ">
          <div className="text-center text-xl ">
            {dataFiltered["dimension"]} - {dataFiltered["title"]}
          </div>
          <div className="my-4 md:px-16 w-full">
            <BarGraph data={dataFiltered}/>
          </div>
          <div className="md:px-16 w-full">
            <div className="mt-4 w-full scroll-design overflow-x-auto shadow-md">
              <ResumeTable data={dataFiltered}/>
            </div>
          </div>
          {dataFiltered.hasTargetGroup &&
            <div className="md:px-16 pt-4 w-full">
              <button
                className="bg-primary text-white py-2 px-4 rounded cursor-pointer hover:bg-dark-primary flex items-center" onClick={onClickDownloadReport}>
                <DownloadIcon className="mr-2" />
                Relatório analítico - Grupo alvo
              </button>
            </div>
          }
          {dataFiltered.reference &&
            <div className="md:px-16 w-full -z-50">
              <ReferenceReport data={dataFiltered}/>
            </div>
          }
        </div>
          :
          <div className="flex flex-col gap-2 w-full justify-center items-center">
            {
              errorMessage ? (
                <div className="flex flex-col gap-2 justify-center items-center p-10">
                  <ReportIcon className="text-green-600" />
                  {errorMessage}
                </div>
              ) :
                <Loading/>
            }
          </div>
      }

    </>
  );
}

export default ModelReportDatesBar;
